<template>
  <div 
    class="documents-empty-state" 
    role="status"
    :aria-label="hasSearch ? 'No documents found matching your search' : 'No documents available'"
  >
    <div class="documents-empty-state__content">
      <!-- Icon -->
      <div class="documents-empty-state__icon" aria-hidden="true">
        <theme-icon icon="file" type="icons" classes="w-16 h-16" />
      </div>
      
      <!-- Message -->
      <h3 class="documents-empty-state__title">
        {{ hasSearch ? 'No documents found' : 'No documents yet' }}
      </h3>
      
      <p class="documents-empty-state__message">
        {{ hasSearch 
          ? 'Try adjusting your search or filters to find what you\'re looking for.' 
          : 'Upload your first document to get started.' 
        }}
      </p>
      
      <!-- Actions -->
      <div class="documents-empty-state__actions">
        <themed-button
          v-if="hasSearch"
          variant="outline"
          @click="$emit('clear-search')"
          aria-label="Clear search and show all documents"
        >
          Clear Search
        </themed-button>
        
        <themed-button
          v-if="canUpload && !hasSearch"
          variant="default"
          @click="$emit('upload')"
          aria-label="Upload your first document"
        >
          <theme-icon icon="upload" type="icons" classes="w-4 h-4" aria-hidden="true" />
          <span>Upload Document</span>
        </themed-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DocumentsEmptyState',
  
  props: {
    hasSearch: {
      type: Boolean,
      default: false
    },
    canUpload: {
      type: Boolean,
      default: false
    }
  }
};
</script>
